export default "{\n    \"viewOptions\": {\n        \"month\": \"Month View\",\n        \"week\": \"Week View\",\n        \"day\": \"Day View\"\n    }\n}\n"